<template>
  <div v-if="isLoading" class="is-relative embed-view-loading">
    <LoadingView :active="true" :is-full-page="false" />
  </div>
  <component
    v-else-if="embedUrl"
    :is="embedComponent"
    :value="embedUrl.value"
    v-bind="embedParams"
  />
</template>

<script>
import { EmbedUrl } from '@/modules/embedurl/models/EmbedUrl';
import EmbedViewFactory from '@/modules/embedurl/factories/EmbedViewFactory';
import { HasContainerMixin } from '@/modules/core/app/mixins/HasContainerMixin';
import LoadingView from '@/modules/core/ui/components/wrappers/LoadingView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'EmbedView',
  mixins: [HasContainerMixin],
  components: {
    LoadingView
  },
  props: {
    embedUrl: {
      type: EmbedUrl
    },
    classes: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    // Only embed components that declare a param consume it (VideoEmbed);
    // the rest fall through as inert root attributes.
    embedParams: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    embedComponent() {
      return EmbedViewFactory.getEmbedComponent(this.embedUrl.type);
    }
  }
};
</script>

<style scoped>
.embed-view-loading {
  aspect-ratio: 16 / 9;
}
</style>
